<template>
  <div
    class="mx-auto flex flex-col px-5 pt-5 sm:px-10 sm:pt-10 lg:flex-row xl:px-28"
  >
    <div
      class="mx-auto mr-5 flex w-full max-w-screen-4xl flex-col space-y-4 pb-9 lg:items-end lg:space-y-5"
    >
      <div
        class="flex w-full flex-col items-start gap-y-6 pt-4 sm:gap-y-4 sm:pt-6"
      >
        <div class="flex w-full items-start justify-between">
          <div class="space-y-2 pt-1.5 sm:space-y-4 sm:pt-0">
            <Skeleton type="custom" class="h-6 w-28 sm:h-7 sm:w-48" />
            <Skeleton type="custom" class="h-2 w-14 sm:h-3" />
          </div>
          <Skeleton type="custom" class="h-9 w-36 sm:hidden" />
        </div>
        <BasketCardSkeleton
          v-for="i in 2"
          :key="`basket-card-skeleton-${i}`"
          class="max-w-4xl"
        />
      </div>
    </div>
    <BasketSummarySkeleton />
  </div>
</template>
